import request from '@/utils/request'

/**
 * 获取权限节点列表数据
 */
export const getAuthLists = (data) => {
    return request({
        url: '/auth/lists',
        params: data
    })
}

/**
 * 获取权限节点tree
 */
export const getAuthTree = (data) => {
    return request({
        url: '/auth/tree',
        params: data
    })
}

/**
 * 获取权限节点选项列表数据
 */
export const getAuthOptionLists = (data) => {
    return request({
        url: '/auth/option/lists',
        params: data
    })
}

/**
 * 权限节点-详情
 */
export const getAuthDetail = (id) => {
    return request({
        url: `/auth/${id}`
    })
}

/**
 * 权限节点-修改
 */
export const putAuth = (data) => {
    return request({
        url: '/auth/manage',
        method: 'PUT',
        data
    })
}

/**
 * 权限节点-添加
 */
export const addAuth = (data) => {
    return request({
        url: '/auth/manage',
        method: 'POST',
        data
    })
}

/**
 * 权限节点-删除
 */
export const delAuth = (id, data) => {
    return request({
        url: `/auth/${id}`,
        method: 'DELETE',
        data
    })
}

// 关于我们
export const getSystemDetail = () => {
    return request({
        url: '/public/info'
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/auth/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
